import { render, staticRenderFns } from "./MatchStatisticsTables.vue?vue&type=template&id=2706a77e&scoped=true"
import script from "./MatchStatisticsTables.vue?vue&type=script&lang=js"
export * from "./MatchStatisticsTables.vue?vue&type=script&lang=js"
import style0 from "./MatchStatisticsTables.vue?vue&type=style&index=0&id=2706a77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706a77e",
  null
  
)

export default component.exports